import { searchGeocoderRanked } from './geocoder-ranked-search'

// TODO: Por ahora se filtran globalmente los POI para poder obtener la mayor cantidad de resultados
const POINTS_OF_INTEREST = [
  'amenity',
  'shop',
  'tourism',
  'leisure',
  'historic',
  'natural',
  'man_made',
  'office'
]

export default {
  /*
   * get() obtiene los puntos de interes a partir de los parámetros
   * del campo origen o destino del planificador. Misma busqueda y ranking
   * por cercania que search-direction; el llamador recorta a LIMIT_SEARCH.
   */
  get(params, skipLoading = false) {
    return searchGeocoderRanked(params, {
      extraParams: POINTS_OF_INTEREST.map(tag => `osm_tag=${tag}`),
      requestOptions: { skipLoading },
      searchKey: 'poi'
    })
  }
}
